'use strict';

var fr_ca = moment.defineLocale('fr-ca', {
    months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact: true,
    weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact: true,
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'YYYY-MM-DD',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[Aujourd\'hui à] LT',
        nextDay: '[Demain à] LT',
        nextWeek: 'dddd [à] LT',
        lastDay: '[Hier à] LT',
        lastWeek: 'dddd [dernier à] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'dans %s',
        past: 'il y a %s',
        s: 'quelques secondes',
        m: 'une minute',
        mm: '%d minutes',
        h: 'une heure',
        hh: '%d heures',
        d: 'un jour',
        dd: '%d jours',
        M: 'un mois',
        MM: '%d mois',
        y: 'un an',
        yy: '%d ans'
    },
    ordinalParse: /\d{1,2}(er|e)/,
    ordinal: function (number) {
        return number + (number === 1 ? 'er' : 'e');
    }
});


//application initialization
var app = angular.module('OSS', ['ui.router', 'duScroll', 'ngAnimate', 'ngMap', 'ngMessages', 'phone-format.dfx', 'dfx.check-connection']);

angular.module('OSS').constant('ApiConstants', require('./global/constants/apiConstants'));
angular.module('OSS').constant('GenericErrorSkipRules', require('./global/constants/genericErrorsSkipRules'));
angular.module('OSS').constant('errors', require('./global/constants/errors'));
angular.module('OSS').constant('RouteConstants', require('./global/constants/routeConstants'));
angular.module('OSS').constant('SettingsConstants', require('./global/constants/settingsConstants'));
angular.module('OSS').constant('VALIDATION', require('./global/constants/validationConstants'));

angular.module('OSS').provider('bootstrapParameters', require('./global/providers/bootstrapParametersProvider'));
angular.module('OSS').provider('apiService', require('./global/services/apiService'));
angular.module('OSS').provider('StatesHistory', require('./global/services/stateHistoryService'));
angular.module('OSS').provider('ssWidgetService', require('./global/services/ssWidgetService'));
angular.module('OSS').provider('sdAnalyticsService', require('./global/services/sdAnalyticsService'));

angular.module('OSS').service('apiStat', require('./global/services/apiResponseStat'));
angular.module('OSS').service('authToken', require('./global/services/authToken'));
angular.module('OSS').service('customerModelService', require('./global/services/customerModelService'));
angular.module('OSS').service('dealerModelService', require('./global/services/dealerModelService'));
angular.module('OSS').service('LoaderService', require('./global/services/loaderService').LoaderService);
angular.module('OSS').service('maintenanceModelService', require('./global/services/maintenanceModelService'));
angular.module('OSS').service('modelFactoryService', require('./global/services/modelFactoryService'));
angular.module('OSS').service('recallParserService', require('./global/services/recallParserService'));
angular.module('OSS').service('VehicleService', require('./global/services/vehicleService'));
angular.module('OSS').service('transportationOptionsService', require('./global/services/transportationOptionsService'));
angular.module('OSS').service('mobileCheckInService', require('./global/services/mobileCheckinService'));

angular.module('OSS').factory('errorRouterService', require('./global/services/errorRouter'));
angular.module('OSS').factory('errorScreenService', require('./global/services/errorScreenService'));
angular.module('OSS').factory('httpInterceptor', require('./global/services/httpInterceptor').HttpInterceptor);
angular.module('OSS').factory('genericApiErrorInterceptor', require('./global/services/httpInterceptor').GenericApiErrorInterceptor);
angular.module('OSS').factory('apiResponseTimeStatisticsInterceptor', require('./global/services/httpInterceptor').ApiResponseTimeStatisticsInterceptor);
angular.module('OSS').factory("changeStateLoader", require('./global/services/loaderService').ChangeStateLoaderService);
angular.module('OSS').factory('createCustomerLoader', require('./pageCreateCustomer/controllers/CreateCustomerController').createCustomerLoader);

angular.module('OSS').filter('calendarFilter', require('./pageScheduled/filters/calendarFilter'));
angular.module('OSS').filter('mileageFilter', require('./global/directives/mileageFilter'));

angular.module('OSS').directive('clickOutside', require('./global/directives/outsideClickDirective'));
angular.module('OSS').directive('addressMap', require('./global/directives/addressMapDirective'));
angular.module('OSS').directive('dateType', require('./global/directives/dateType'));
angular.module('OSS').directive('errorMessage', require('./global/directives/errorMessage'));
angular.module('OSS').directive('errorScreen', require('./global/directives/errorScreen'));
angular.module('OSS').directive('header', require('./global/directives/headerDirective'));
angular.module('OSS').directive('horyzontalScrollContent', require('./global/directives/horyzontalScrollDirective'));
angular.module('OSS').directive('noTimeSlot', require('./global/directives/noTimeSlotDirective'));
angular.module('OSS').directive('onlyNumber', require('./global/directives/onlyNumber'));
angular.module('OSS').directive("ossFocusError", require('./global/directives/ossFocusError'));
angular.module('OSS').directive('ossRecall', require('./global/directives/ossRecallDirective').default);
angular.module('OSS').directive('vehicleAlert', require('./global/directives/vehicleAlertDirective').default);
angular.module('OSS').directive('protectionPlan', require('./global/directives/protectionPlanDirective').default);
angular.module('OSS').directive("ossSliderArrows", require('./global/directives/ossSliderArrows'));
angular.module('OSS').directive("ossUnderline", require('./global/directives/ossUnderline'));
angular.module('OSS').directive('serviceItem', require('./global/directives/serviceItemDirective'));
angular.module('OSS').directive('verticalScrollContent', require('./global/directives/verticalScrollDirective').verticalScrollContentDirective);
angular.module('OSS').directive('verticalScrollContentItem', require('./global/directives/verticalScrollDirective').verticalScrollContentItemDirective);
angular.module('OSS').directive('serviceContractWarning', require('./global/directives/serviceContractWarningDirective'));

require('./global/directives/dfxDropdown')(angular.module('OSS'));

angular.module('OSS').directive('vinDecode', require('./global/directives/vinDecodeDirective'));
angular.module('OSS').directive('regexp', require('./global/validators/regexp'));
angular.module('OSS').directive('mileageScrollItem', require('./pageFactoryRequired/directives/mileageScrollDirective'));
angular.module('OSS').directive('transportationOptionsScrollItem', require('./pageScheduled/directives/transportationOptionsScrollDirective'));
angular.module('OSS').directive('vehicleSelector', require('./pageSearchResults/directives/vehicleSelectorDirective'));
angular.module('OSS').directive('datePicker', require('./pageScheduled/directives/datepickerDirective'));

angular.module('OSS').controller('globalController', require('./global/controllers/globalController'));
angular.module('OSS').controller('OtherwiseCtrl', require('./global/controllers/otherwiseController'));
angular.module('OSS').controller('AppointmentSummaryCtrl', require('./pageAppointmentSummary/controllers/appointmentSummaryController'));
angular.module('OSS').controller('BookAppointmentCtrl', require('./pageBookAppointment/controllers/bookAppointmentController'));
angular.module('OSS').controller('CancelAppointmentCtrl', require('./pageCancelAppointment/controllers/cancelAppointmentController'));
angular.module('OSS').controller('ConfirmationCtrl', require('./pageConfirmation/controllers/confirmationController'));
angular.module('OSS').controller('CreateCustomerCtrl', require('./pageCreateCustomer/controllers/CreateCustomerController').CreateCustomerCtrl);
angular.module('OSS').controller('CreateCustomerDriveTrainCtrl', require('./pageCreateCustomerDriveTrain/controllers/createCustomerDriveTrainController'));
angular.module('OSS').controller('CreateCustomerEngineCtrl', require('./pageCreateCustomerEngine/controllers/crateCustomerEngineController'));
angular.module('OSS').controller('CreateCustomerManufacturerCtrl', require('./pageCreateCustomerManufacturer/controllers/createCustomerManufacturerController'));
angular.module('OSS').controller('CreateCustomerModelCtrl', require('./pageCreateCustomerModel/controllers/createCustomerModelController'));
angular.module('OSS').controller('CreateCustomerOverViewCtrl', require('./pageCreateCustomerOverview/controllers/createCustomerOverviewController'));
angular.module('OSS').controller('CreateCustomerTransmissionCtrl', require('./pageCreateCustomerTransmission/controllers/createCustomerTransmissionController'));
angular.module('OSS').controller('CreateCustomerYearCtrl', require('./pageCreateCustomerYear/controllers/createCustomerYearController'));
angular.module('OSS').controller('CustomerConcernsCtrl', require('./pageCustomerConcerns/controllers/cutomerConcernsController'));
angular.module('OSS').controller('DealerRecommendedCtrl', require('./pageDealerRecommended/controllers/dealerRecommendedController'));
angular.module('OSS').controller('FactoryRequiredCtrl', require('./pageFactoryRequired/controllers/factoryRequiredController'));
angular.module('OSS').controller('NewCustomerCtrl', require('./pageNewCustomer/controllers/newCustomerController'));
angular.module('OSS').controller('NewVehicleCtrl', require('./pageNewVehicle/controllers/newVehicleController'));
angular.module('OSS').controller('ServicesRequiredCtrl', require('./pageNoServices/controllers/servicesRequiredCtrl'));
angular.module('OSS').controller('ScheduleCtrl', require('./pageScheduled/controllers/scheduledController'));
angular.module('OSS').controller('SearchResultsCtrl', require('./pageSearchResults/controllers/searchResultsController'));
angular.module('OSS').controller('VehicleCheckHealthCtrl', require('./pageVehicleCheckHealth/controllers/vehicleCheckHealthController'));
angular.module('OSS').controller('VehicleDetailsCtrl', require('./pageVehicleDetails/controllers/vehicleDetailsController'));
angular.module('OSS').controller('VehicleUpdatesCtrl', require('./pageVehicleUpdates/controllers/vehicleUpdatesController'));
angular.module('OSS').controller('WellcomeCtrl', require('./pageWellcome/controllers/wellcomeController'));
angular.module('OSS').controller('SurveyCtrl', require('./pageSurvey/controllers/surveyController'));
angular.module('OSS').controller('ByConfirmationCodeController', require('./pageByConfirmationCode/controllers/byConfirmationCodeController'));

app.config(require('./app.config'))
    .filter('unsafe', ['$sce', function ($sce) {
        return $sce.trustAsHtml;
    }])
    .run(require('./app.run'))
    .run(require('./app.maintenanceMenu.init'));

module.exports = 'OSS';
